import { render, staticRenderFns } from "./PhoneDisclaimer.vue?vue&type=template&id=bcb47290&"
import script from "./PhoneDisclaimer.vue?vue&type=script&lang=js&"
export * from "./PhoneDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PhoneDisclaimer.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports